import type { Catalog } from '../../core/types/catalog'

/**
 * Wat er nog naar een behandeling of protocol verwijst. Zolang dit niet leeg is, kan het niet weg:
 * een huidthema heeft altijd precies één protocol en één behandeling (verplichte velden), dus
 * "opruimen" zou een stille keuze voor Sarah zijn. Het beheer blokkeert verwijderen en noemt waar
 * het nog aan hangt. Kuurproducten volgen uit de behandeling zelf (core/rules/kuur.ts) en tellen
 * daarom niet mee.
 */

type Links = Pick<Catalog, 'routines' | 'concerns'>

export const treatmentLinks = (c: Links, slug: string): string[] => [
  ...c.routines.filter((r) => r.treatmentSlug === slug).map((r) => `protocol ${r.name}`),
  ...c.concerns.filter((x) => x.treatmentSlug === slug).map((x) => `huidthema ${x.label}`),
]

export const routineLinks = (c: Pick<Catalog, 'concerns'>, id: string): string[] =>
  c.concerns.filter((x) => x.routineId === id).map((x) => `huidthema ${x.label}`)

/** De melding bij de verwijderknop, of `undefined` als het weg mag. */
export const deleteBlockedReason = (links: string[], fix: string): string | undefined =>
  links.length ? `Kan nog niet: gekoppeld aan ${links.join(', ')}. ${fix}` : undefined
